define('home/mixins/withEmailVerificationAlert',[
    'underscore',

    'core/advice',

    'home/views/EmailVerificationAlertView',
], function (
    _,

    advice,

    EmailVerificationAlertView
) {
    'use strict';

    return function withEmailVerificationAlert() {
        advice.withAdvice.call(this);

        this.before('onDomRefresh', function () {
            // Support both Marionette Layouts and Views using withSubviews
            if (this.activateRegion) {
                this.activateRegion(this.emailVerificationAlertRegion, function () {
                    return new EmailVerificationAlertView();
                });
            } else {
                this.emailVerificationAlertRegion.show(new EmailVerificationAlertView());
            }
        });

        this.regions = _.defaults({
            emailVerificationAlertRegion: '[data-role=email-verification-alert]',
        }, this.regions);
    };
});

